import { IBaseMapper } from '@/bundles/App/interfaces';
import { IBadge } from '@/bundles/Badge/interfaces';
import Badge from '@/bundles/Badge/models/Badge';

export default class BadgeToMapper implements IBaseMapper<IBadge> {
  mapToModel (data: IBadge) {
    return new Badge(data);
  }
}
